import { render } from "./SubscribePlanItemDescription.vue?vue&type=template&id=1e97164b"
import script from "./SubscribePlanItemDescription.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscribePlanItemDescription.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Subscribe/SubscribePlanItemDescription.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1e97164b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1e97164b', __exports__)) {
    api.reload('1e97164b', __exports__)
  }
  
  module.hot.accept("./SubscribePlanItemDescription.vue?vue&type=template&id=1e97164b", () => {
    api.rerender('1e97164b', render)
  })

}


export default __exports__